import { UnitFormData } from './helpers';

export type TariffModality = NonNullable<UnitFormData['tariffModality']>;
export type TariffSubgroup = NonNullable<UnitFormData['tariffSubgroup']>;
export type UnitType = NonNullable<UnitFormData['unitType']>;

export const TARIFF_MODALITY_OPTIONS: { value: TariffModality; label: string }[] = [
  { value: 'GREEN', label: 'A Verde' },
  { value: 'BLUE', label: 'A Azul' },
  { value: 'B3_OPTING', label: 'B Optante' },
  { value: 'B3_STANDARD', label: 'Baixa Tensão' },
];

const A_SUBGROUPS: TariffSubgroup[] = ['A1', 'A2', 'A3', 'A3A', 'A4', 'AS'];
const B_SUBGROUPS: TariffSubgroup[] = ['B1', 'B2', 'B3'];

export function isAModality(modality?: string | null): boolean {
  return modality === 'GREEN' || modality === 'BLUE';
}

export function isBModality(modality?: string | null): boolean {
  return modality === 'B3_OPTING' || modality === 'B3_STANDARD';
}

export function showsDemandPeak(modality?: string | null): boolean {
  return modality === 'BLUE';
}

export function showsContractedDemands(modality?: string | null): boolean {
  return isAModality(modality);
}

export function getSubgroupOptions(modality?: string | null): { value: TariffSubgroup; label: string }[] {
  const values = isBModality(modality) ? B_SUBGROUPS : isAModality(modality) ? A_SUBGROUPS : [];
  return values.map((value) => ({ value, label: value }));
}

export function getUnitTypeOptions(
  modality?: string | null,
  subgroup?: string | null,
): { value: UnitType; label: string }[] {
  if (isAModality(modality)) {
    return [
      { value: 'COMMERCIAL', label: 'Comercial' },
      { value: 'INDUSTRIAL', label: 'Industrial' },
      { value: 'RURAL', label: 'Rural' },
    ];
  }

  if (subgroup === 'B1') {
    return [{ value: 'RESIDENTIAL', label: 'Residencial' }];
  }
  if (subgroup === 'B2') {
    return [{ value: 'RURAL', label: 'Rural' }];
  }
  if (subgroup === 'B3') {
    return [
      { value: 'COMMERCIAL', label: 'Comercial' },
      { value: 'INDUSTRIAL', label: 'Industrial' },
    ];
  }

  return [];
}

export function isSubgroupValidForModality(modality?: string | null, subgroup?: string | null): boolean {
  if (!modality || !subgroup) return false;
  return getSubgroupOptions(modality).some((opt) => opt.value === subgroup);
}

export function isUnitTypeValidForCascade(
  modality?: string | null,
  subgroup?: string | null,
  unitType?: string | null,
): boolean {
  if (!unitType) return false;
  return getUnitTypeOptions(modality, subgroup).some((opt) => opt.value === unitType);
}
